import { render } from "./HorsePreview.vue?vue&type=template&id=078c6be1"
import script from "./HorsePreview.vue?vue&type=script&lang=js"
export * from "./HorsePreview.vue?vue&type=script&lang=js"

import "./HorsePreview.vue?vue&type=style&index=0&id=078c6be1&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__